/**
 * Facturas PDF de pedidos — flujo presigned (port de kit-stock/src/lib/invoice.ts).
 */
import type { trpc } from '@/lib/trpc';

type TrpcClient = ReturnType<typeof trpc.useUtils>['client'];

export const MAX_INVOICE_SIZE = 10 * 1024 * 1024; // 10 MB

export function validateInvoiceFile(file: File): string | null {
  const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
  if (!isPdf) return 'Solo se aceptan archivos PDF';
  if (file.size > MAX_INVOICE_SIZE) return 'El archivo supera el límite de 10 MB';
  return null;
}

/** Sube una factura PDF para un pedido (presigned PUT) y la adjunta. */
export async function uploadInvoice(client: TrpcClient, orderId: string, file: File) {
  const { uploadUrl, key } = await client.kits.getInvoiceUploadUrl.mutate({
    orderId,
    name: file.name,
    size: file.size,
    contentType: file.type || 'application/pdf',
  });
  const put = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': 'application/pdf' },
  });
  if (!put.ok) throw new Error('Error al subir el archivo');
  return client.kits.attachInvoice.mutate({ orderId, key });
}

/** Abre la factura del pedido en una pestaña nueva (URL firmada de S3). */
export async function openInvoice(client: TrpcClient, orderId: string) {
  const { url } = await client.kits.getInvoiceUrl.query({ orderId });
  window.open(url, '_blank', 'noopener');
}
